<template>
    <div>
    
        <p>
            {{ $t('DeviceTest.MicrophoneTest.Confirm') }}
        </p>
            <div class="py-1">
                {{ $t('DeviceTest.MicrophoneTest.Select') }}<select id="MicSelect" name="MicSelect"></select>
            </div>
            
        <div class="pids-wrapper d-flex justify-content-between">
            <div class="pid"></div>
            <div class="pid"></div>
            <div class="pid"></div>
            <div class="pid"></div>
            <div class="pid"></div>
            <div class="pid"></div>
            <div class="pid"></div>
            <div class="pid"></div>
            <div class="pid"></div>
            <div class="pid"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AudioInputTest',
    data () {
        return {
            MicSelect:document.querySelector('select#MicSelect'),
            MicSelectId:'',
        }
    },
    mounted(){
        // debugger;
        if (!!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
            // Good to go!
        } else {
            alert('getUserMedia() is not supported by your browser');
        }
        
        this.$nextTick(function () {
            this.askForPermission();

            document.querySelector('#MicSelect').onchange = () => {
                let new_selection = document.querySelector('#MicSelect').children[
                    document.querySelector('#MicSelect').selectedIndex
                ].value;
                this.MicSelectId = new_selection

                this.MicSelect = document.querySelector('#MicSelect').children[document.querySelector('#MicSelect').selectedIndex].text;
                this.setMic();
            };

            navigator.mediaDevices.ondevicechange = event => {
                document.querySelector('#MicSelect').innerHTML = '';
                this.askForPermission();
            }   
            
        })
    },
    methods:{
        askForPermission:function(){
            var constraints = { audio : true };
            navigator.mediaDevices.getUserMedia(constraints)
            .then(() => {
                this.populateMicList();
                this.GLOBAL.AUDIOInputOK = true;
            })
            .catch(() => {
                this.NoDevice();
                // console.error(err);
            });
        },
        populateMicList:function(){
            var count = 0;
            document.querySelector('#MicSelect').innerHTML = '';
            navigator.mediaDevices.enumerateDevices().then((deviceList) => {
                // console.log(deviceList);
                // this.MicSelect = deviceList.filter((x) => x.kind == 'audioinput')[0].deviceId;
                this.MicSelect = deviceList.filter((x) => x.kind == 'audioinput')[0].label;
                this.MicSelectId = deviceList.filter((x) => x.kind == 'audioinput')[0].deviceId;
                this.setMic();

                deviceList.forEach((device) => {
                    if (device.kind == 'audioinput') {
                        count+=1;
                        let item = document.createElement('option');
                        item.value = device.deviceId;
                        if(device.label == ""){
                            item.innerHTML = this.$t('DeviceTest.Default');
                        }else{
                            item.innerHTML = device.label;
                        }
                        document.querySelector('#MicSelect').appendChild(item);
                    }
                });
                
                if(count = 0){
                    this.NoDevice();
                }
            });
        },
        setMic:function(){
            // if (window.stream) {
            //     window.stream.getTracks().forEach(track => {
            //         track.stop();
            //     });
            // }

            this.GLOBAL.selectedAudioInput = this.MicSelect;
            var constraints = {
                audio: {
                    deviceId: this.MicSelectId ? {exact: this.MicSelectId} : undefined
                }
            };

            navigator.mediaDevices.getUserMedia(constraints).then(function(stream) {
                window.stream = stream; // make stream available to console
                const audioContext = new AudioContext();
                const analyser = audioContext.createAnalyser();
                const microphone = audioContext.createMediaStreamSource(stream);
                const scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1);

                analyser.smoothingTimeConstant = 0.8;
                analyser.fftSize = 1024;

                microphone.connect(analyser);
                analyser.connect(scriptProcessor);
                scriptProcessor.connect(audioContext.destination);
                scriptProcessor.onaudioprocess = function() {
                    const array = new Uint8Array(analyser.frequencyBinCount);
                    analyser.getByteFrequencyData(array);
                    const arraySum = array.reduce((a, value) => a + value, 0);
                    const average = arraySum / array.length;
                    const allPids = [...document.querySelectorAll('.pid')];
                    const numberOfPidsToColor = Math.round(average / 10);
                    const pidsToColor = allPids.slice(0, numberOfPidsToColor);
                    for (const pid of allPids) {
                        pid.style.backgroundColor = "#e6e7e8";
                    }
                    for (const pid of pidsToColor) {
                        // console.log(pid[i]);
                        pid.style.backgroundColor = "#69ce2b";
                    }
                };
            })
            .catch(function(err) {
                /* handle the error */
                console.error(err);
            });
        },
        NoDevice(){
            let item = document.createElement('option');
            item.innerHTML = this.$t('DeviceTest.MicrophoneTest.NoDevice');
            document.querySelector('#MicSelect').appendChild(item);
            this.GLOBAL.AUDIOInputOK = false;
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/DeviceTestPages/AudioInputTest.vue